import api from '@/api'
export default {
  getCenterListBySystem (params) {
    return api({
      url: '/trainCamp/trainCampListSystem',
      method: 'GET',
      params
    })
  },
  getCenterListByOrg (params) {
    return api({
      url: '/trainCamp/trainCampListOrgan',
      method: 'GET',
      params
    })
  },
  addCenter (data) {
    return api({
      url: '/trainCamp/trainCampAdd',
      method: 'POST',
      data
    })
  },
  updateCenter (data) {
    return api({
      url: '/trainCamp/trainCampEdit',
      method: 'PUT',
      data
    })
  },
  getCenterInfo (uuid) {
    return api({
      url: `/youth/trainCampInfo/${uuid}`,
      method: 'GET'
    })
  },
  getListByOrg (uuid) {
    return api({
      url: `/organ/authorizationOrganListOrgan/${uuid}`,
      method: 'GET'
    })
  },
  getListBySystem (params) {
    return api({
      url: '/organ/authorizationOrganListSystem',
      method: 'GET',
      params
    })
  },
  getYouthSettingData (params) {
    return api({
      url: '/trainCamp/trainCampSettingData',
      method: 'GET',
      params
    })
  },
  setYouthSettingData (data) {
    return api({
      url: '/trainCamp/trainCampSettingSave',
      method: 'POST',
      data
    })
  }
}
